import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ExternalUsageComponent } from './external-usage.component';
import { TabsComponent } from './tabs/tabs.component';


const routes: Routes = [
  {
    path: '',
    component: ExternalUsageComponent,
    children: [
      {
        path: '',
        component: TabsComponent,
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalUsageRoutingModule { }
